<template>
    <div>
        <base-button
            @click="showSizeGuide"
            class="h-auto lg:underline normal-case text-sm font-light tracking-normal"
        >
            {{ $t('SIZE_GUIDE') }}
        </base-button>

        <size-guide-modal
            @modalClose="showModal = false"
            :show-modal="showModal"
        />
    </div>
</template>

<script>
    import BaseButton from './BaseButton.vue';
    import SizeGuideModal from './SizeGuideModal.vue';

    export default {
        components: {
            BaseButton,
            SizeGuideModal,
        },

        data() {
            return {
                showModal: false,
            };
        },

        methods: {
            showSizeGuide() {
                this.showModal = true;
            },
        },
    };
</script>
